import { Component } from "@theme/component";
import { DialogCloseEvent } from "@theme/dialog";
import { ZoomMediaSelectedEvent } from "@theme/events";

const desktopViewer = window.matchMedia(
  "(min-width: 750px) and (hover: hover) and (pointer: fine)"
);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
);

document.getElementById("rn-viewer-interaction-styles")?.remove();

const styleId = "realest-fitted-viewer-styles";
let viewerStyle = document.getElementById(styleId);

if (!viewerStyle) {
  viewerStyle = document.createElement("style");
  viewerStyle.id = styleId;
  document.head.appendChild(viewerStyle);
}

const scope = "body dialog.rn-fit-viewer.rn-reel-viewer";

viewerStyle.textContent = `
  ${scope} {
    --rn-reel-height: min(358px, calc(100dvh - 160px));

    position: fixed !important;
    inset: 0 !important;
    width: 100vw !important;
    max-width: none !important;
    height: 100dvh !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: rgba(0, 0, 0, 0.82) !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    animation: none !important;
    transition: none !important;
    transform: none !important;
    translate: none !important;
    scale: none !important;
  }

  ${scope}::backdrop {
    background: transparent;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
  }

  ${scope} .dialog-zoomed-gallery {
    position: absolute !important;
    inset: 0 !important;
    display: grid !important;
    place-items: center !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    gap: 0 !important;
    overflow: hidden !important;
    list-style: none !important;
    box-sizing: border-box !important;
    animation: none !important;
    transform: none !important;
    translate: none !important;
  }

  ${scope} .dialog-zoomed-gallery
    > [data-rn-selected="false"] {
    display: none !important;
  }

  ${scope} .dialog-zoomed-gallery
    > [data-rn-selected="true"] {
    position: relative !important;
    grid-area: 1 / 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex: none !important;

    width: min(
      calc(90dvh * var(--rn-photo-ratio, 0.667)),
      calc(100vw - 200px)
    ) !important;

    height: min(
      90dvh,
      calc((100vw - 200px) / var(--rn-photo-ratio, 0.667))
    ) !important;

    min-width: 0 !important;
    max-width: calc(100vw - 200px) !important;
    min-height: 0 !important;
    max-height: 90dvh !important;
    margin: 0 !important;
    padding: 0 !important;
    aspect-ratio: auto !important;
    overflow: hidden !important;
    background: transparent !important;
    animation: none !important;
    transform: none !important;
    translate: none !important;
  }

  ${scope} [data-rn-selected="true"]
    .product-media__drag-zoom-wrapper,
  ${scope} [data-rn-selected="true"]
    drag-zoom-wrapper,
  ${scope} [data-rn-selected="true"]
    .product-media {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    aspect-ratio: auto !important;
    overflow: hidden !important;
    transform: none !important;
    translate: none !important;
  }

  ${scope} .dialog-zoomed-gallery img.product-media__image {
    position: relative !important;
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: 100% !important;
    aspect-ratio: auto !important;
    object-fit: contain !important;
    object-position: center !important;

    transform: scale(var(--rn-viewer-scale, 1)) !important;
    transform-origin:
      var(--rn-viewer-x, 50%)
      var(--rn-viewer-y, 50%) !important;

    transition:
      transform 600ms cubic-bezier(0.22, 1, 0.36, 1),
      transform-origin 400ms cubic-bezier(0.16, 1, 0.3, 1)
      !important;

    cursor: none !important;
  }

  ${scope} .dialog-zoomed-gallery
    > .product-media-container--image[data-rn-selected="true"],
  ${scope} .dialog-zoomed-gallery
    > .product-media-container--image[data-rn-selected="true"] * {
    cursor: none !important;
  }

  ${scope} .dialog-thumbnails-list-container {
    position: absolute !important;
    inset: 70px 18px 70px auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 68px !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    translate: none !important;
    scale: none !important;
    animation: none !important;
    transition: none !important;
    overflow: hidden !important;
    pointer-events: auto !important;
    z-index: 5 !important;
  }

  ${scope} .dialog-thumbnails-list-container
    > .dialog-thumbnails-list {
    position: relative !important;
    inset: auto !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
    flex: none !important;
    gap: 12px !important;
    width: 64px !important;
    height: var(--rn-reel-height) !important;
    min-height: 0 !important;
    max-height: 100% !important;
    margin: 0 !important;

    padding:
      calc((var(--rn-reel-height) - 62px) / 2)
      6px !important;

    box-sizing: border-box !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    translate: none !important;
    scale: none !important;
    animation: none !important;
    transition: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    overscroll-behavior: contain;
    scroll-behavior: auto !important;
    scrollbar-width: none !important;
    pointer-events: auto !important;

    mask-image: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(0, 0, 0, 0.3) 12%,
      #000 34%,
      #000 66%,
      rgba(0, 0, 0, 0.3) 88%,
      transparent 100%
    ) !important;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(0, 0, 0, 0.3) 12%,
      #000 34%,
      #000 66%,
      rgba(0, 0, 0, 0.3) 88%,
      transparent 100%
    ) !important;
  }

  ${scope} .dialog-thumbnails-list::after {
    content: none !important;
    display: none !important;
    animation: none !important;
    transition: none !important;
  }

  ${scope} .dialog-thumbnails-list::-webkit-scrollbar {
    display: none !important;
  }

  ${scope} .dialog-thumbnails-list-container
    .dialog-thumbnails-list
    > button.dialog-thumbnails-list__thumbnail {
    position: relative !important;
    display: block !important;
    flex: 0 0 62px !important;
    width: 44px !important;
    min-width: 44px !important;
    max-width: 44px !important;
    height: 62px !important;
    min-height: 62px !important;
    max-height: 62px !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    border: 1px solid transparent !important;
    border-radius: 3px !important;
    outline: none !important;
    box-shadow: none !important;
    background: #fff !important;
    anchor-name: none !important;
    visibility: visible !important;
    opacity: var(--rn-thumb-opacity, 0.25) !important;
    transform: none !important;
    translate: none !important;
    scale: none !important;
    animation: none !important;
    cursor: pointer !important;

    transition:
      opacity 350ms cubic-bezier(0.16, 1, 0.3, 1)
      !important;
  }

  ${scope} .dialog-thumbnails-list-container
    .dialog-thumbnails-list
    > button.dialog-thumbnails-list__thumbnail[aria-selected="true"] {
    border-color: #fff !important;
    opacity: 1 !important;
  }

  ${scope} .dialog-thumbnails-list-container
    .dialog-thumbnails-list
    > button.dialog-thumbnails-list__thumbnail:focus-visible {
    outline: 1px solid #fff !important;
    outline-offset: 2px !important;
  }

  ${scope} .dialog-thumbnails-list-container
    .dialog-thumbnails-list > button img {
    position: static !important;
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    aspect-ratio: auto !important;
    object-fit: contain !important;
    object-position: center !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    translate: none !important;
    scale: none !important;
    animation: none !important;
    transition: none !important;
    cursor: pointer !important;
  }

  ${scope} .dialog-zoomed-gallery__close-button {
    position: absolute !important;
    top: 20px !important;
    right: 24px !important;
    bottom: auto !important;
    left: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    height: 40px !important;
    padding: 10px !important;
    color: #fff !important;
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    z-index: 6 !important;
    cursor: pointer !important;
  }

  ${scope} .rn-viewer-cursor {
    position: fixed !important;
    display: block !important;
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    pointer-events: none !important;
    z-index: 10 !important;
    color: #fff !important;
    background: transparent !important;
    font-family: inherit;
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 1 !important;
    letter-spacing: 0 !important;
    text-transform: lowercase !important;
    white-space: nowrap !important;
    mix-blend-mode: difference !important;
    transform: translate(-50%, -50%) !important;
    opacity: 0;
  }

  ${scope} video,
  ${scope} model-viewer {
    max-width: 100%;
    max-height: 100%;
  }

  @media (prefers-reduced-motion: reduce) {
    ${scope} .dialog-zoomed-gallery img.product-media__image,
    ${scope} .dialog-thumbnails-list-container
      .dialog-thumbnails-list
      > button.dialog-thumbnails-list__thumbnail {
      transition: none !important;
    }
  }
`;

export class ZoomDialog extends Component {
  requiredRefs = ["dialog", "media", "thumbnails"];

  activeIndex = 0;
  pendingIndex = null;
  returnFocus = null;
  previousOverflow = null;
  viewerLabel = null;
  selectionToken = 0;
  mediaAnimations = [];
  reelFrame = null;
  wheelContainer = null;
  wheelTotal = 0;
  wheelReadyAt = 0;
  lastWheelEvent = 0;

  connectedCallback() {
    super.connectedCallback();

    const dialog = this.refs.dialog;
    dialog.classList.add("rn-fit-viewer", "rn-reel-viewer");

    this.viewerLabel?.remove();
    this.viewerLabel = document.createElement("span");
    this.viewerLabel.className = "rn-viewer-cursor";
    this.viewerLabel.textContent = "+zoom.";
    this.viewerLabel.setAttribute("aria-hidden", "true");
    dialog.appendChild(this.viewerLabel);

    this.wheelContainer = dialog;

    this.wheelContainer?.addEventListener(
      "wheel",
      this.handleReelWheel,
      { passive: false }
    );

    dialog.addEventListener("pointermove", this.handlePointerMove);
    dialog.addEventListener("pointerleave", this.resetMagnification);
    dialog.addEventListener("click", this.handleViewerClick, true);
    dialog.addEventListener("cancel", this.handleCancel);
    dialog.addEventListener("close", this.handleDialogClosed);

    desktopViewer.addEventListener("change", this.handleDeviceChange);
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    const dialog = this.refs.dialog;

    this.wheelContainer?.removeEventListener(
      "wheel",
      this.handleReelWheel
    );

    dialog.removeEventListener("pointermove", this.handlePointerMove);
    dialog.removeEventListener("pointerleave", this.resetMagnification);
    dialog.removeEventListener("click", this.handleViewerClick, true);
    dialog.removeEventListener("cancel", this.handleCancel);
    dialog.removeEventListener("close", this.handleDialogClosed);

    desktopViewer.removeEventListener(
      "change",
      this.handleDeviceChange
    );

    window.removeEventListener("resize", this.handleResize);

    this.cancelMotion();
    this.viewerLabel?.remove();
    this.viewerLabel = null;

    if (dialog.open) dialog.close();

    this.restoreScrolling();
    super.disconnectedCallback();
  }

  cancelMotion() {
    this.selectionToken++;

    this.mediaAnimations.forEach((animation) => {
      animation.cancel();
    });

    this.mediaAnimations = [];

    if (this.reelFrame !== null) {
      cancelAnimationFrame(this.reelFrame);
      this.reelFrame = null;
    }

    this.pendingIndex = null;
  }

  setPhotoProportions(item) {
    const image = item?.querySelector(
      "img.product-media__image"
    );

    if (!image) {
      item?.style.setProperty("--rn-photo-ratio", "1.5");
      return;
    }

    const width =
      image.naturalWidth ||
      Number(image.getAttribute("width"));

    const height =
      image.naturalHeight ||
      Number(image.getAttribute("height"));

    if (width > 0 && height > 0) {
      item.style.setProperty(
        "--rn-photo-ratio",
        String(width / height)
      );
    } else if (!image.dataset.rnRatioListener) {
      image.dataset.rnRatioListener = "true";

      image.addEventListener(
        "load",
        () => {
          if (image.naturalWidth && image.naturalHeight) {
            item.style.setProperty(
              "--rn-photo-ratio",
              String(
                image.naturalWidth / image.naturalHeight
              )
            );
          }
        },
        { once: true }
      );
    }
  }

  open(index, event) {
    event?.preventDefault();

    if (!desktopViewer.matches) return;

    const selectedIndex = Number(index);

    if (
      !Number.isInteger(selectedIndex) ||
      !this.refs.media[selectedIndex]
    ) {
      return;
    }

    const dialog = this.refs.dialog;

    if (!dialog.open) {
      this.returnFocus = document.activeElement;
      this.selectThumbnail(selectedIndex);

      this.previousOverflow =
        document.documentElement.style.overflow;

      document.documentElement.style.overflow = "hidden";
      dialog.showModal();

      this.wheelTotal = 0;
      this.wheelReadyAt = 0;
      this.lastWheelEvent = 0;

      requestAnimationFrame(() => {
        if (dialog.open) this.centerThumbnail(false);
      });
    } else {
      this.selectThumbnail(selectedIndex);
    }

    const originalLabel = document.querySelector(
      ".zoom-cursor-label"
    );

    if (originalLabel) originalLabel.style.opacity = "0";

    this.querySelector(
      ".dialog-zoomed-gallery__close-button"
    )?.focus({ preventScroll: true });
  }

  selectThumbnail(index) {
    const selectedIndex = Number(index);
    const media = Array.from(this.refs.media);
    const incoming = media[selectedIndex];

    if (!Number.isInteger(selectedIndex) || !incoming) return;

    const previous = media[this.activeIndex];
    const changed = selectedIndex !== this.activeIndex;
    const dialog = this.refs.dialog;

    const animate =
      changed &&
      dialog.open &&
      !reducedMotion.matches &&
      previous?.classList.contains(
        "product-media-container--image"
      ) &&
      incoming.classList.contains(
        "product-media-container--image"
      );

    this.cancelMotion();
    const token = this.selectionToken;

    this.resetMagnification();

    media.forEach((item) => {
      this.setPhotoProportions(item);

      item.querySelectorAll(
        "img.product-media__image"
      ).forEach((image) => {
        image.style.setProperty(
          "transition",
          "none",
          "important"
        );

        image.style.removeProperty("--rn-viewer-scale");
        image.style.removeProperty("--rn-viewer-x");
        image.style.removeProperty("--rn-viewer-y");
      });
    });

    this.activeIndex = selectedIndex;
    this.pendingIndex = animate ? selectedIndex : null;

    media.forEach((item, itemIndex) => {
      const selected = itemIndex === selectedIndex;
      const outgoing = animate && item === previous;

      item.dataset.rnSelected = String(selected || outgoing);
      item.setAttribute("aria-hidden", String(!selected));
      item.style.zIndex = selected ? "2" : "1";

      if (!selected) {
        item.querySelectorAll("video").forEach((video) => {
          video.pause();
        });
      }
    });

    Array.from(this.refs.thumbnails.children).forEach(
      (button, buttonIndex) => {
        const distance = Math.abs(
          buttonIndex - selectedIndex
        );

        button.setAttribute(
          "aria-selected",
          String(distance === 0)
        );

        button.style.setProperty(
          "--rn-thumb-opacity",
          distance === 0
            ? "1"
            : distance === 1
              ? "0.5"
              : "0.25"
        );
      }
    );

    this.loadHighResolutionImage(incoming);

    if (animate) {
      const timing = {
        duration: 280,
        easing: "cubic-bezier(0.32, 0.72, 0, 1)"
      };

      const outgoingAnimation = previous.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        timing
      );

      const incomingAnimation = incoming.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        timing
      );

      this.mediaAnimations = [
        outgoingAnimation,
        incomingAnimation
      ];

      Promise.all(
        this.mediaAnimations.map((animation) =>
          animation.finished.catch(() => {})
        )
      ).then(() => {
        if (token !== this.selectionToken) return;

        media.forEach((item, itemIndex) => {
          item.dataset.rnSelected = String(
            itemIndex === selectedIndex
          );
        });

        this.mediaAnimations = [];
        this.pendingIndex = null;
      });
    }

    requestAnimationFrame(() => {
      if (token !== this.selectionToken) return;

      incoming.getBoundingClientRect();

      media.forEach((item) => {
        item.querySelectorAll(
          "img.product-media__image"
        ).forEach((image) => {
          image.style.removeProperty("transition");
        });
      });

      if (dialog.open) this.centerThumbnail(changed);
    });

    this.dispatchEvent(
      new ZoomMediaSelectedEvent(selectedIndex)
    );
  }

  centerThumbnail(animate = true) {
    const strip = this.refs.thumbnails;
    const button = strip.children[this.activeIndex];

    if (!button || !strip.clientHeight) return;

    if (this.reelFrame !== null) {
      cancelAnimationFrame(this.reelFrame);
      this.reelFrame = null;
    }

    const stripBounds = strip.getBoundingClientRect();
    const buttonBounds = button.getBoundingClientRect();

    const target = Math.max(
      0,
      Math.min(
        strip.scrollHeight - strip.clientHeight,
        strip.scrollTop +
          buttonBounds.top -
          stripBounds.top -
          (strip.clientHeight - buttonBounds.height) / 2
      )
    );

    if (!animate || reducedMotion.matches) {
      strip.scrollTop = target;
      return;
    }

    const start = strip.scrollTop;
    const distance = target - start;
    const startedAt = performance.now();

    const step = (now) => {
      const progress = Math.min(
        1,
        (now - startedAt) / 440
      );

      const eased = 1 - Math.pow(1 - progress, 4);
      strip.scrollTop = start + distance * eased;

      if (progress < 1 && this.refs.dialog.open) {
        this.reelFrame = requestAnimationFrame(step);
      } else {
        this.reelFrame = null;
      }
    };

    this.reelFrame = requestAnimationFrame(step);
  }

  handleReelWheel = (event) => {
    if (
      !this.refs.dialog.open ||
      !desktopViewer.matches ||
      event.ctrlKey ||
      !event.deltaY
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const now = performance.now();

    if (now - this.lastWheelEvent > 160) {
      this.wheelTotal = 0;
    }

    this.lastWheelEvent = now;

    if (now < this.wheelReadyAt) return;

    const multiplier =
      event.deltaMode === 1
        ? 16
        : event.deltaMode === 2
          ? this.refs.thumbnails.clientHeight
          : 1;

    const delta = event.deltaY * multiplier;

    if (
      this.wheelTotal &&
      Math.sign(delta) !== Math.sign(this.wheelTotal)
    ) {
      this.wheelTotal = 0;
    }

    this.wheelTotal += delta;

    if (Math.abs(this.wheelTotal) < 36) return;

    const direction = this.wheelTotal > 0 ? 1 : -1;
    const count = this.refs.media.length;

    const next = Math.max(
      0,
      Math.min(count - 1, this.activeIndex + direction)
    );

    this.wheelTotal = 0;
    this.wheelReadyAt = now + 380;

    if (next !== this.activeIndex) {
      this.selectThumbnail(next);
    } else {
      this.centerThumbnail(true);
    }
  };

  loadHighResolutionImage(mediaContainer) {
    const image = mediaContainer?.querySelector(
      "img.product-media__image"
    );

    const source = image?.getAttribute("data_max_resolution");

    if (
      !image ||
      !source ||
      image.dataset.rnHighResolution === "true"
    ) {
      return false;
    }

    image.dataset.rnHighResolution = "true";

    const preload = new Image();

    preload.onload = () => {
      image.removeAttribute("srcset");
      image.src = source;

      if (preload.naturalWidth && preload.naturalHeight) {
        mediaContainer.style.setProperty(
          "--rn-photo-ratio",
          String(
            preload.naturalWidth / preload.naturalHeight
          )
        );
      }
    };

    preload.onerror = () => {
      delete image.dataset.rnHighResolution;
    };

    preload.src = source;
    return true;
  }

  handleThumbnailClick(index) {
    this.selectThumbnail(index);
  }

  handleThumbnailPointerEnter(index) {
    this.loadHighResolutionImage(
      this.refs.media[Number(index)]
    );
  }

  handlePointerMove = (event) => {
    if (!desktopViewer.matches) {
      this.resetMagnification();
      return;
    }

    const image = this.refs.media[this.activeIndex]?.querySelector(
      "img.product-media__image"
    );

    if (
      !image ||
      event.target !== image ||
      this.pendingIndex !== null
    ) {
      this.resetMagnification();
      return;
    }

    if (this.viewerLabel) {
      this.viewerLabel.style.left = event.clientX + "px";
      this.viewerLabel.style.top = event.clientY + "px";
      this.viewerLabel.style.opacity = "1";
    }

    const bounds =
      image.parentElement.getBoundingClientRect();

    if (!bounds.width || !bounds.height) return;

    const x = Math.max(
      0,
      Math.min(
        100,
        ((event.clientX - bounds.left) / bounds.width) * 100
      )
    );

    const y = Math.max(
      0,
      Math.min(
        100,
        ((event.clientY - bounds.top) / bounds.height) * 100
      )
    );

    image.style.setProperty("--rn-viewer-x", x + "%");
    image.style.setProperty("--rn-viewer-y", y + "%");
    image.style.setProperty("--rn-viewer-scale", "2");
  };

  resetMagnification = () => {
    if (this.viewerLabel) {
      this.viewerLabel.style.opacity = "0";
    }

    Array.from(this.refs.media).forEach((item) => {
      item.querySelectorAll(
        "img.product-media__image"
      ).forEach((image) => {
        image.style.removeProperty("--rn-viewer-scale");
        image.style.removeProperty("--rn-viewer-x");
        image.style.removeProperty("--rn-viewer-y");
      });
    });
  };

  handleViewerClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const item = event.target.closest(
      '[data-rn-selected="true"]'
    );

    if (item) {
      if (
        item.classList.contains(
          "product-media-container--image"
        )
      ) {
        event.stopPropagation();
      }

      return;
    }

    if (
      event.target === this.refs.dialog ||
      event.target.classList.contains(
        "dialog-zoomed-gallery"
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }
  };

  handleKeyDown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.close();
      return;
    }

    if (
      event.key !== "ArrowRight" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowDown" &&
      event.key !== "ArrowUp"
    ) {
      return;
    }

    if (
      event.target instanceof Element &&
      event.target.closest(
        "video, input, textarea, select, [contenteditable]"
      )
    ) {
      return;
    }

    event.preventDefault();

    const count = this.refs.media.length;
    if (!count) return;

    const forward =
      event.key === "ArrowRight" ||
      event.key === "ArrowDown";

    const next = Math.max(
      0,
      Math.min(
        count - 1,
        this.activeIndex + (forward ? 1 : -1)
      )
    );

    if (next !== this.activeIndex) {
      this.selectThumbnail(next);
    }
  }

  handleCancel = (event) => {
    event.preventDefault();
    this.close();
  };

  handleDeviceChange = () => {
    if (!desktopViewer.matches) this.close();
  };

  handleResize = () => {
    if (this.refs.dialog.open) {
      this.centerThumbnail(false);
    }
  };

  restoreScrolling() {
    if (this.previousOverflow === null) return;

    document.documentElement.style.overflow =
      this.previousOverflow;

    this.previousOverflow = null;
  }

  handleDialogClosed = () => {
    this.cancelMotion();
    this.resetMagnification();
    this.restoreScrolling();

    this.wheelTotal = 0;
    this.wheelReadyAt = 0;
    this.lastWheelEvent = 0;

    Array.from(this.refs.media).forEach((item, index) => {
      item.dataset.rnSelected = String(
        index === this.activeIndex
      );

      item.querySelectorAll("video").forEach((video) => {
        video.pause();
      });
    });

    this.returnFocus?.focus?.({ preventScroll: true });
    this.returnFocus = null;

    window.dispatchEvent(new DialogCloseEvent());
  };

  close() {
    if (this.refs.dialog.open) {
      this.refs.dialog.close();
    }
  }

  closeDialog() {
    this.close();
  }
}

if (!customElements.get("zoom-dialog")) {
  customElements.define("zoom-dialog", ZoomDialog);
}
